import { getAPICall } from "lib/callApi";
import {
  GET_MANAGER_PERFORMANCE_FOR_HOME,
  GET_COMPANY_ADMIN_MANAGER_PERFORMANCE,
} from "lib/constants";

export const fetchManagerPerformance = async (payload) => {
  // call with dynamic
  const data = await getAPICall(`${GET_COMPANY_ADMIN_MANAGER_PERFORMANCE}`, true, payload);
  // const data = await getAPICall(
  //   `${GET_COMPANY_ADMIN_MANAGER_PERFORMANCE}?startDate=2022-11-16&endDate=2022-11-16`,
  //   true
  // );
  return data;
};

export const fetchManagerPerformanceForHome = async (payload) => {
  // call with dynamic
  const data = await getAPICall(`${GET_MANAGER_PERFORMANCE_FOR_HOME}`, true, payload);
  // const data = await getAPICall(
  //   `${GET_COMPANY_ADMIN_MANAGER_PERFORMANCE}?startDate=2022-11-16&endDate=2022-11-16`,
  //   true
  // );
  return data;
};
